import { Box, Button, Text } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import SectionTitle from "../Common/SectionTitle";
import { PiReadCvLogo } from "react-icons/pi";
import { GetResumeURL } from "../../Services/firebase";

export const About = () => {
  const [resumeURL, setResumeURL] = useState("");
  useEffect(() => {
    GetResumeURL()
      .then((res) => {
        if (res && res.length > 0) {
          setResumeURL(res[0]);
        }
      })
      .catch((err) => {
        console.log(err);
        setResumeURL("");
      });
  }, []);
  return (
    <Box>
      <SectionTitle title="In My Own Words" />
      <Box color="#FAFAFA" px={{ base: "1.5rem", md: "3rem" }}>
        <Text
          fontSize="1.25rem"
          lineHeight={{ base: "1.5", sm: "1.4" }}
          letterSpacing="0.3px"
          mb="1rem"
          textAlign={{ base: "justify", md: "left" }}
        >
          &nbsp; &nbsp; I&#39;m a seasoned software engineer with a passion for
          crafting elegant, optimized solutions. With a keen eye for detail, I
          approach coding challenges by first envisioning the overall structure
          of a product, ensuring a holistic perspective that encompasses
          technical excellence, user experience, and functionality.
        </Text>
        <Text
          fontSize="1.25rem"
          lineHeight={{ base: "1.5", sm: "1.4" }}
          letterSpacing="0.3px"
          mb="1rem"
          textAlign={{ base: "justify", md: "left" }}
        >
          &nbsp; &nbsp; Over the years, I&#39;ve honed my skills in building
          stunning websites that seamlessly blend form and function. My goal is
          to create user-friendly, attractive digital experiences that not only
          meet client needs but also leave a lasting impression. I pride myself
          on adding a personal touch to each project, ensuring it&#39;s both
          eye-catching and intuitive.
        </Text>
        <Text
          fontSize="1.25rem"
          lineHeight={{ base: "1.5", sm: "1.4" }}
          letterSpacing="0.3px"
          mb="1rem"
          textAlign={{ base: "justify", md: "left" }}
        >
          &nbsp; &nbsp; I thrive on mixing art with coding, transforming complex
          problems into creative solutions. Let’s collaborate to bring your
          vision to life!
        </Text>
        <Box w="full" display="flex" justifyContent="center">
          <Button
            type="submit"
            maxW="100%"
            mx="auto"
            my="1rem"
            bg="linear-gradient(to bottom right,rgb(64,64,64) 0%,rgb(64,64,64) 50%)"
            color="#ffdb70"
            display="flex"
            justifyContent="center"
            alignItems="center"
            gap="10px"
            boxShadow="0px 16px 40px #00000020"
            borderRadius="14px"
            fontSize="1rem"
            fontWeight="semibold"
            p="16px 20px"
            onClick={() => {
              resumeURL.length > 0 && window.open(resumeURL, "_blank");
            }}
          >
            <PiReadCvLogo fontSize="1.5rem" />
            <Text>Resume</Text>
          </Button>
        </Box>
      </Box>
    </Box>
  );
};
